
// Centralized news data - Edit this file to add/update news articles
export interface NewsArticle {
  id: number;
  title: string;
  excerpt: string;
  content: string;
  date: string;
  category: string;
  image: string;
  externalUrl?: string; // Optional external URL for news articles
  videoUrl?: string; // Optional video URL for articles
  gallery?: string[]; // Optional image gallery
}

export const newsArticles: NewsArticle[] = [
  {
    id: 1,
    title: "Ọmọ Odùduwà Community Outreach Program",
    excerpt: "Our community members actively engaging with local leaders and spreading awareness about our mission across Yoruba communities.",
    content: `
      <p>Our recent community outreach program has been a tremendous success, reaching out to various communities across the Yoruba land. The program focused on building stronger connections with local leaders and community members.</p>
      
      <p>Key highlights of the program include:</p>
      <ul>
        <li>Direct engagement with community elders and traditional leaders</li>
        <li>Distribution of educational materials about our mission</li>
        <li>Building partnerships for future collaborative projects</li>
        <li>Strengthening cultural ties and preserving Yoruba heritage</li>
      </ul>
      
      <p>The positive response from community members has been overwhelming, with many expressing interest in joining our movement and contributing to the preservation and advancement of Yoruba culture and values.</p>
      
      <p>We extend our gratitude to all community leaders who welcomed us and supported our mission. Together, we continue to build a stronger, more unified Yoruba community.</p>
    `,
    date: "May 27, 2025",
    category: "Community Outreach",
    image: "/lovable-uploads/04f635a5-1a25-4eea-8262-4d852b1c50c0.png",
    gallery: [
      "/lovable-uploads/04f635a5-1a25-4eea-8262-4d852b1c50c0.png",
      "/lovable-uploads/f19722f1-67bd-4341-95df-b2ab5e68a63b.png",
      "/lovable-uploads/b3fb8202-d542-4658-bb1e-d37d428b40ef.png"
    ],
    videoUrl: "https://dppptcbparmacmlpdqbn.supabase.co/storage/v1/object/public/images/video_2025-06-01_13-00-22.mp4"
  },
  {
    id: 2,
    title: "Market Engagement Initiative",
    excerpt: "Connecting with traders and market women to promote economic empowerment and cultural unity within our communities.",
    content: `
      <p>Our market engagement initiative has brought us closer to the heart of our communities - the bustling markets where trade and culture intersect daily.</p>
      
      <p>Program objectives included:</p>
      <ul>
        <li>Supporting local traders and market women</li>
        <li>Promoting economic empowerment through micro-finance initiatives</li>
        <li>Strengthening cultural identity in commercial spaces</li>
        <li>Building networks for mutual support and growth</li>
      </ul>
      
      <p>The response from market leaders has been exceptional, with many expressing appreciation for our efforts to support local businesses and preserve cultural values in modern economic activities.</p>
      
      <p>This initiative represents our commitment to holistic community development that encompasses both cultural preservation and economic advancement.</p>
    `,
    date: "May 28, 2025",
    category: "Economic Empowerment",
    image: "/lovable-uploads/f19722f1-67bd-4341-95df-b2ab5e68a63b.png",
    gallery: [
      "/lovable-uploads/f19722f1-67bd-4341-95df-b2ab5e68a63b.png",
      "/lovable-uploads/04f635a5-1a25-4eea-8262-4d852b1c50c0.png"
    ],
    videoUrl: "https://dppptcbparmacmlpdqbn.supabase.co/storage/v1/object/public/images/video_2025-06-01_13-00-55%20(1).mp4"
  },
  {
    id: 3,
    title: "Cultural Heritage Day",
    excerpt: "Celebrating our shared Yoruba identity through art, dance, and history.",
    content: `
      <p>The Cultural Heritage Day brought together hundreds of participants from across our communities to celebrate our rich Yoruba heritage.</p>
      
      <p>Event highlights included:</p>
      <ul>
        <li>Live performances of traditional Yoruba music and dance</li>
        <li>Exhibitions of indigenous crafts and artwork</li>
        <li>Workshops on Ifá, Òrìṣà worship, and oral storytelling</li>
        <li>Cultural education sessions for youth and elders</li>
      </ul>
      
      <p>It was a day of pride, connection, and cultural education for all ages, reinforcing our commitment to preserving and promoting Yoruba traditions for future generations.</p>
    `,
    date: "May 30, 2025",
    category: "Culture",
    image: "/lovable-uploads/b3fb8202-d542-4658-bb1e-d37d428b40ef.png",
    gallery: [
      "/lovable-uploads/b3fb8202-d542-4658-bb1e-d37d428b40ef.png",
      "/lovable-uploads/04f635a5-1a25-4eea-8262-4d852b1c50c0.png",
      "/lovable-uploads/f19722f1-67bd-4341-95df-b2ab5e68a63b.png"
    ],
    videoUrl: "https://dppptcbparmacmlpdqbn.supabase.co/storage/v1/object/public/images/video_2025-06-01_14-13-25.mp4"
  },
  {
    id: 4,
    title: "Women's Empowerment & Cultural Education",
    excerpt: "Empowering women through education, cultural awareness, and leadership development programs across Yoruba communities.",
    content: `
      <p>Our women's empowerment program continues to make significant impact across various communities, focusing on education, cultural preservation, and leadership development.</p>
      
      <p>Key program components:</p>
      <ul>
        <li>Leadership training workshops for women</li>
        <li>Cultural education and heritage preservation</li>
        <li>Economic empowerment through skill development</li>
        <li>Mentorship programs connecting generations</li>
      </ul>
      
      <p>The program has reached hundreds of women across different age groups, from young mothers to respected elders, creating a network of empowered women who are driving positive change in their communities.</p>
      
      <p>We celebrate the strength, wisdom, and resilience of Yoruba women and their vital role in preserving our culture while building a brighter future for the next generation.</p>
    `,
    date: "May 28, 2025",
    category: "Women's Empowerment",
    image: "/lovable-uploads/449e360b-a4b0-4688-9584-a9b95c587882.png",
    gallery: [
      "/lovable-uploads/449e360b-a4b0-4688-9584-a9b95c587882.png",
      "/lovable-uploads/80e03cb8-5f58-4fca-868c-4c091f4f14bc.png",
      "/lovable-uploads/12446434-3667-474a-a053-b3720448c4d9.png"
    ]
  },
  {
    id: 5,
    title: "Community Leadership Summit",
    excerpt: "Bringing together community leaders to discuss strategies for cultural preservation and community development.",
    content: `
      <p>Our Community Leadership Summit brought together influential leaders from across Yoruba communities to discuss critical issues affecting our people and develop actionable strategies for progress.</p>
      
      <p>Summit highlights:</p>
      <ul>
        <li>Strategic planning for community development projects</li>
        <li>Cultural preservation and modernization balance</li>
        <li>Youth engagement and leadership succession</li>
        <li>Economic development and job creation initiatives</li>
      </ul>
      
      <p>The summit resulted in concrete action plans and commitments from various community leaders to work together towards common goals of cultural preservation and community advancement.</p>
      
      <p>This collaborative approach ensures that our efforts are coordinated and impactful, creating lasting positive change in our communities.</p>
    `,
    date: "May 28, 2024",
    category: "Leadership",
    image: "/lovable-uploads/329a8613-ea43-4452-b558-6b143334bc24.png"
  },
  {
    id: 6,
    title: "Economic Development Initiative",
    excerpt: "Supporting local businesses and promoting economic growth within Yoruba communities.",
    content: `
      <p>Our economic development initiative focuses on creating sustainable economic opportunities for community members while preserving our cultural identity.</p>
      
      <p>Program features:</p>
      <ul>
        <li>Small business development and mentorship</li>
        <li>Access to microfinance and funding opportunities</li>
        <li>Skills training and capacity building workshops</li>
        <li>Market linkages and networking events</li>
      </ul>
      
      <p>Through these initiatives, we aim to create a thriving economic ecosystem that benefits all community members while maintaining our cultural values and traditions.</p>
    `,
    date: "May 25, 2025",
    category: "Economic Empowerment",
    image: "/lovable-uploads/9344e2d2-edd3-4dca-8385-fddbad3decba.png"
  },
  {
    id: 7,
    title: "Youth Engagement Program",
    excerpt: "Inspiring and empowering the next generation of Yoruba leaders through education and cultural activities.",
    content: `
      <p>Our youth engagement program is designed to inspire and empower young people to take active roles in preserving and advancing Yoruba culture and community development.</p>
      
      <p>Program activities include:</p>
      <ul>
        <li>Cultural education and language preservation workshops</li>
        <li>Leadership development and mentorship programs</li>
        <li>Community service and volunteer opportunities</li>
        <li>Skills development and career guidance sessions</li>
      </ul>
      
      <p>By investing in our youth, we ensure the continuity of our cultural heritage and the development of future leaders who will carry our values forward.</p>
    `,
    date: "May 22, 2025",
    category: "Youth Development",
    image: "/lovable-uploads/f3fe5f57-0f54-43ce-99d7-d549e66f80b7.png",
    gallery: [
      "/lovable-uploads/f3fe5f57-0f54-43ce-99d7-d549e66f80b7.png",
      "/lovable-uploads/fb723c85-19c1-4309-9a9f-d07f7f99ab28.png"
    ]
  }
];

// Helper function to get article by ID
export const getArticleById = (id: number): NewsArticle | undefined => {
  return newsArticles.find(article => article.id === id);
};

// Helper function to get articles by category
export const getArticlesByCategory = (category: string): NewsArticle[] => {
  if (category === "All") return newsArticles;
  return newsArticles.filter(article => article.category === category);
};
